module.exports = __webpack_public_path__ + "static/img/logo2.e2f11764.png";